module.exports = __webpack_public_path__ + "static/network8-914296ec419ef02cbfd32781154de2c9.png";